import moment from 'moment';
import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { ConfigService } from '../../services/config/config.service';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { TimeUtilities } from '../../utilities/time-utilities';
import { NumberModel } from '../primitive/number.model';
import { TextModel } from '../primitive/text.model';
import { CompositeModel } from './composite.model';

export class TaskModel extends CompositeModel {
    public pos: NumberModel;
    public notificationNo: TextModel;
    public taskNumber: TextModel;
    public taskCode: TextModel;
    public plannedStart: moment.Moment;
    public plannedEnd: moment.Moment;
    public constructor(
        pos: number,
        notificationNo: string,
        task: string,
        taskCode: string,
        plannedStartDate: string,
        plannedStartTime: string,
        plannedEndDate: string,
        plannedEndTime: string,
    ) {
        super('TaskModel');
        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigService);
        this.pos = <NumberModel>this.set(new NumberModel('Pos', pos));
        this.notificationNo = <TextModel>this.set(new TextModel('NotificationNo', notificationNo));
        this.taskNumber = <TextModel>this.set(new TextModel('TaskNumber', task));
        this.taskCode = <TextModel>this.set(new TextModel('TaskCode', taskCode));
        // get  config to determine if moment need to be created in UTC or no
        const formatMomentInUtc = configService.getFormatMomentInUTC();
        // TRAV and OSR are sent by user in their local (ipad) timezone, so do not convert them to UTC
        const isUTC =
            formatMomentInUtc &&
            taskCode !== NOTIFICATION_STATUS_CODE.TRAV &&
            taskCode !== NOTIFICATION_STATUS_CODE.OSR;
        this.plannedStart = TimeUtilities.momentFromDateAndTime(plannedStartDate, plannedStartTime, isUTC);
        this.plannedEnd = TimeUtilities.momentFromDateAndTime(plannedEndDate, plannedEndTime, isUTC);
    }

    public static fromOData(data: ODataTaskModel): TaskModel {
        return new TaskModel(
            data.Counter,
            data.NotificationNo,
            data.TaskNumber,
            data.TaskCode,
            data.PlannedStartDate,
            data.PlannedStartTime,
            data.PlannedFinishDate,
            data.PlannedFinishTime,
        );
    }
}

export interface ODataTaskModel extends ODataObject {
    Counter: number;
    NotificationNo: string;
    TaskNumber: string;
    TaskCode: string;
    PlannedStartDate: string;
    PlannedStartTime: string;
    PlannedFinishDate: string;
    PlannedFinishTime: string;
    __metadata: {
        uri: string;
        id: string;
        type: 'HC_SM_NGM_58_SRV.Task';
    };
}
